import { render, staticRenderFns } from "./ClipboardPulseIcon.vue?vue&type=template&id=5e3a0c1c"
import script from "./ClipboardPulseIcon.vue?vue&type=script&lang=js"
export * from "./ClipboardPulseIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports